import { useState } from 'react';

const isLocalhost = window.location.hostname === 'localhost';

export default function DevBanner() {
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem('devbanner_open') !== 'false'; }
    catch { return true; }
  });

  if (!isLocalhost) return null;

  const toggle = () => {
    const next = !open;
    try { localStorage.setItem('devbanner_open', String(next)); } catch {}
    setOpen(next);
  };

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
  const truncated   = supabaseUrl.length > 40 ? supabaseUrl.slice(0, 40) + '…' : supabaseUrl;
  const backendUrl  = process.env.REACT_APP_BACKEND_URL || '';

  const bannerStyle = {
    position: 'fixed',
    bottom: 0, left: 0, right: 0,
    zIndex: 9999,
    width: '100%',
    height: open ? 36 : 24,
    overflow: 'hidden',
    background: 'rgba(8,13,22,0.95)',
    borderTop: '1px solid rgba(0,229,255,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
    boxSizing: 'border-box',
    transition: 'height 0.2s ease',
    fontFamily: "'Manrope', sans-serif",
    fontSize: 11,
    color: '#00E5FF',
    userSelect: 'none',
  };

  const badgeStyle = {
    background: '#00E5FF',
    color: '#080d16',
    borderRadius: 4,
    fontSize: 10,
    fontWeight: 700,
    padding: '1px 6px',
    letterSpacing: '0.06em',
    flexShrink: 0,
  };

  const sepStyle = {
    color: 'rgba(0,229,255,0.3)',
    margin: '0 8px',
    flexShrink: 0,
  };

  const dimStyle = {
    color: 'rgba(0,229,255,0.55)',
    flexShrink: 0,
  };

  const valStyle = {
    color: '#00E5FF',
    flexShrink: 0,
  };

  const toggleStyle = {
    background: 'rgba(0,229,255,0.1)',
    border: '1px solid rgba(0,229,255,0.3)',
    borderRadius: 4,
    color: '#00E5FF',
    fontFamily: "'Manrope', sans-serif",
    fontSize: 10,
    fontWeight: 700,
    padding: '2px 8px',
    cursor: 'pointer',
    letterSpacing: '0.04em',
    flexShrink: 0,
    lineHeight: 1.4,
  };

  return (
    <div style={bannerStyle}>
      {open && (
        <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', gap: 0, minWidth: 0 }}>
          <span style={badgeStyle}>DEV</span>
          <span style={sepStyle}>·</span>
          <span style={dimStyle}>env:&nbsp;</span>
          <span style={valStyle}>{process.env.NODE_ENV}</span>
          <span style={sepStyle}>·</span>
          <span style={dimStyle}>supabase:&nbsp;</span>
          <span style={{ ...valStyle, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{truncated}</span>
          <span style={sepStyle}>·</span>
          <span style={dimStyle}>backend:&nbsp;</span>
          <span style={{ ...valStyle, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{backendUrl}</span>
        </div>
      )}
      <div style={{ marginLeft: 'auto', flexShrink: 0 }}>
        <button onClick={toggle} style={toggleStyle}>
          {open ? '▲ hide' : '▼ dev'}
        </button>
      </div>
    </div>
  );
}
